import { components } from "@certn/legacy-api/generated-schemas/people";
import { formatDate } from "@certn/utils";
import { t } from "i18next";

import { getSchema } from "./schema";

export function getAddressDate(
  address: components["schemas"]["AddressesCheckField"]["value"][0]
) {
  return `${formatDate(address.start_date, "MMM yyyy")} - ${
    address.end_date ? formatDate(address.end_date, "MMM yyyy") : t("Present")
  }`;
}

export function getAddressWithUnit(
  address: components["schemas"]["AddressesCheckField"]["value"][0]
) {
  return address.unit ? `${address.unit}-${address.address}` : address.address;
}

export function getMissingCountries(
  addresses: components["schemas"]["AddressesCheckField"]["value"],
  requestedCountries: string[]
) {
  const countries = new Set();

  addresses.forEach(({ country, province_state }) => {
    countries.add(country);

    // include Scotland, Wales, England and Northern Ireland as countries
    if (["GB", "UK"].includes(country)) {
      countries.add(province_state);
    }
  });

  const result: string[] = [];

  requestedCountries.forEach((country) => {
    if (!countries.has(country)) {
      result.push(country);
    }
  });

  return result;
}

export function hasMultipleCurrentAddresses(
  addresses: components["schemas"]["AddressesCheckField"]["value"]
) {
  return addresses.filter(({ end_date }) => !end_date).length > 1;
}

export function getErrorMessage(
  address: components["schemas"]["AddressesCheckField"]["value"][0],
  addresses: components["schemas"]["AddressesCheckField"]["value"]
) {
  if (!address.end_date && hasMultipleCurrentAddresses(addresses)) {
    return t("Only one current address allowed.");
  }

  const schema = getSchema(!address.end_date);
  try {
    schema.validateSync(address);
  } catch {
    return t("Invalid address. Please fix all errors or delete this entry.");
  }
}
